<!--monitoring:批阅监控 2024/03/11 09:58:35 YuAng-->

<template>
  <div class="marking-monitoring cnt1200">
    <page-header :title="title" :paths="['考试列表', '批阅监控']"></page-header>
    <div class="monitoring-part">
      <div class="part-btns">
        <div>
          <el-button v-for="(btn, index) in btns" :key="'btn' + index" :type="activeBtn === btn ? 'primary' : ''" @click="routerTo(btn)">
            {{ btn.name }}
          </el-button>
        </div>
        <div v-if="$route.query.isGrading === 'GRADING_DONE'&&!isRegion">
          <el-button size="small" type="primary" @click="exportData">导出数据</el-button>
        </div>
      </div>
      <keep-alive>
        <router-view :isClassMark="isClassMark" :assignMode="assignMode"></router-view>
      </keep-alive>
    </div>

    <export-modal :reportList="reportList" @click-item="clickItem" ref="exportModal"></export-modal>
  </div>
</template>
<script>
import PageHeader from '@/v2/views/components/PageHeader.vue'
import ExportModal from '@/v2/views/components/ExportModal.vue'
import { mapGetters } from 'vuex'
import { reportApi, gradingApi } from '@/v2/utils/api'

export default {
  name: 'monitoring',
  components: { PageHeader, ExportModal },
  data () {
    return {
      btns: [
        {
          name: '批阅进度',
          value: 'progress'
        },
        {
          name: '评分分布',
          value: 'spread'
        },
        {
          name: '阅卷质量',
          value: 'quality'
        },
        {
          name: '抽样复评',
          value: 'monitor'
        },
        {
          name: '抽查试卷',
          value: 'check'
        }
      ],
      pQuery: {}, // 父路由的query
      activeBtn: {},
      reportList: [],
      exportTypes: [
        "SCHOOL_QUALITY",
        "SCHOOL_DISTRIBUTION",
        "SCHOOL_REVIEW_SUPERVISION"
      ],
      isClassMark: false,
      assignMode: '',
      isRegion: this.$route.query.isRegion + '' === 'true'
    }
  },
  computed: {
    title: function () {
      const { examName, subjectName } = this.pQuery
      return examName + '-' + subjectName
    },
    ...mapGetters({
      userInfo: 'getUserInfo',
    }),
  },
  created () {
    // 临时方案，非监控页面不执行, 原因：1）BasePage为顶层父组件（缓存模式）和其他顶层冲突 2）本页面用了存在嵌套路由，属于3级嵌套
    // 复现步骤：考试列表-阅卷监控-档案追踪时会触发
    if (this.$route.name.indexOf('monitoring') < 0) {
      return
    }
    this.pQuery = this.$route.query
    this.getAssignMode()
    // 跳转到指定tab按钮的路由
    let btn = this.btns.find(item => this.$route.path.indexOf('/monitoring/' + item.value) >= 0)
    if (!btn) {
      btn = this.btns[0]
    }
    this.activeBtn = btn
  },
  methods: {
    routerTo (btn) {
      this.activeBtn = btn
      // 首次的时候id来自父路由，而刷新时来自自己的params.id
      const id = this.pQuery.id || this.$route.params.id
      this.$router.replace({ path: `/v2/exam/monitoring/${btn.value}/${id}`, query: this.pQuery });
    },
    clickItem: function (info) {
      this[info.method](info.params)
    },
    // 获取批阅报告列表
    exportData (isOpen = true) {
      const params = {
        examId: this.pQuery.id || this.$route.params.id,
        schoolId: this.userInfo.schoolId,
        types: this.exportTypes
      }
      reportApi.getReadMarkExportList(params).then(res => {
        if (res.success) {
          this.reportList = res.body;
        } else {
          this.$message.warning(res.$message)
        }
        this.$refs.exportModal.open()
      })
    },
    // 导出批阅报告
    createReadMarkExport (param) {
      const params = this.getExportParams(param.row)
      reportApi[`${param.type}ReadMarkExport`](params).then(res => {
        if (res.success) {
          this.exportData(false)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 获取报告参数
    getExportParams (row) {
      const id = this.pQuery.id || this.$route.params.id
      return {
        id: row ? row.id : "",
        examId: id,
        schoolId: this.userInfo.schoolId,
        paramModel: {
          examId: id,
          schoolId: this.userInfo.schoolId,
          type: row.category,
          async: true
        }
      }
    },
    // 获取批阅模式
    async getAssignMode () {
      const params = {
        examId: this.pQuery.id || this.$route.params.id,
        schoolId: this.userInfo.schoolId
      }
      if (this.isRegion) {
        params.schoolId = this.$route.query.regionId
      }

      const res = await gradingApi.getAssignMode(params)
      if (res.success) {
        this.assignMode = res.body
        this.isClassMark = res.body === 'CLASS'
        // 在分班批阅模式下隐藏抽样复评
        if (this.isClassMark) {
          this.btns = this.btns.filter(s => s.value != 'monitor')
        }
      } else {
        this.$message.warning(res.message)
      }
    },
  }
}
</script>

<style scoped>
.monitoring-part {
  margin-top: 16px;
  background-color: white;
  min-height: 400px;
  padding-bottom: 50px;
}

.marking-monitoring ::v-deep .page-header {
  border: none;
}

.marking-monitoring ::v-deep .header-middle {
  color: #333;
  font-size: 16px;
  font-style: normal;
}

.part-btns {
  padding: 16px 32px;
  border-bottom: 1px solid #f5f6f7;
  display: flex;
  justify-content: space-between;
}

.part-btns ::v-deep .el-button {
  padding: 9px 16px;
}

.part-btns ::v-deep .el-button--default {
  background-color: #f3f3f3;
}
</style>